module.exports = __webpack_public_path__ + "static/media/paws.c63b6069.png";